import { useEffect, useState } from 'react'

export function useCoinGeckoPrices() {
  const [prices, setPrices] = useState<{ [key: string]: { usd: number } } | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    async function fetchPrices() {
      try {
        setLoading(true)
        const response = await fetch('/api/coingecko-prices') // Llama al endpoint local
        if (!response.ok) {
          throw new Error(`API Error: ${response.statusText}`)
        }
        const data = await response.json()
        setPrices(data)
        setError(null)
      } catch (err: any) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchPrices()
    const interval: NodeJS.Timeout = setInterval(fetchPrices, 30000)

    return () => clearInterval(interval)
  }, [])

  return { prices, error, loading }
}
